import React from "react";
import { Button, Grid } from "@mui/material";
// import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import AddCommitteeMemberModal from "./AddCommitteeMemberModal";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import Pagination from "@mui/material/Pagination";
// End

function CommitteeManagementNew() {
  const navigate = useNavigate();
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );
  // For memu
  const [anchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open2, setOpen] = React.useState(false);
  const [scroll2, setScroll] = React.useState("paper");
  const [selectedResident, setSelectedResident] = React.useState();
  const [designation, setDesignation] = React.useState();
  const [q, setQ] = React.useState("");
  const [commiteeMemlist, setCommiteeMemlist] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [residentName, setresidentName] = React.useState('');

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);


  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleClickOpen2 = (scrollType, opt, commiteeMemId, selDesignation) => () => {

    localStorage.setItem('isCommiteeMemEdit', true);
    // localStorage.setItem('selectedCommiteeMem',commiteeMemId);
    // localStorage.setItem('selectedDesignation',selDesignation);
    let username = opt.user_obj.first_name + ' ' + opt.user_obj.last_name;
    console.log('prt op', username)
    setresidentName(username)
    setSelectedResident(commiteeMemId)
    setDesignation(selDesignation)
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose2 = () => {
    setOpen(false);
    localStorage.removeItem('isCommiteeMemEdit');
    localStorage.removeItem('selectedCommiteeMem');
    localStorage.removeItem('selectedDesignation');
  };


  async function commiteeMemberlisting() {

    let bodyFormData = {
      searchq: q,
      pageNo: currentPage,
      count: itemsPerPage,
    };
    // setShowLoader(true);
    await makePostRequest("resident/commiteememlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.rows);
          // setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setCommiteeMemlist(data);
          setTotalItems(response.data.data.total_records);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        let errMsg = err.response.data.message;
        swal(errMsg, "", "warning");
        setShowLoader(false);
      });
  }

  async function deleteCommiteeMem(id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: ["No", "Yes"],
      // dangerMode: true,
    });

    if (willDelete) {
      let inputdata = {
        resident_id: id,
        user_designation: null
      }

      await makePostRequest("resident/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Commitee Member Deleted Successfully", "success", {
              timer: 3000,
              buttons: false,
            });
            window.location.reload();
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal(" " + err.response.data.message, "", "warning", {
            timer: 2000,
            buttons: false,
          });
        });
    }
  }

  async function handleChangeDesignation(e) {
    // alert(e.target.value);
    setDesignation(e.target.value);
  }

  async function addCommiteeMember() {
    setShowLoader(true);
    let inputdata = {
      resident_id: selectedResident,
      user_designation: designation
    }

    await makePostRequest("resident/update", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          swal("Success", "Commitee Member Updated Successfully", "success", {
            timer: 1000,
            buttons: false,
          });
          handleClose2();
          commiteeMemberlisting()
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal(" " + err.response.data.message, "", "warning", {
          timer: 2000,
          buttons: false,
        });
      });
  }


  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    commiteeMemberlisting();
  }, [open, q, currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">Committee Management </div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input type="text" placeholder="Search" onChangeCapture={(e) => setQ(e.target.value)} />
                    {/* <MicIcon className="visitorMicIco" /> */}
                  </div>
                  {/* <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClose}>Filter Item 1</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 2</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 3</MenuItem>
                  </Menu> */}
                </div>

                {commiteeMemlist ?
                  <>
                    {commiteeMemlist.map((option) => (
                      <div className="visitContDiv">
                        <div className="visitCont1 resideNewContOut">
                          <div className="visitContProf">
                            {option.user_obj.profile_pic ? (
                              <img src={option.user_obj.profile_pic} />
                            ) : (
                              <img src={defaultProfilePic} />
                            )}
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> {option.user_obj.first_name}{" "}
                              {option.user_obj.last_name}{" "}</h3>
                            <p className="visitContMob">{option.user_obj.contact_no}</p>
                            <p className="visitContTime">{option.user_obj.email_id}</p>
                          </div>
                          {option.apartment ? (
                            <div className="visitBottCont">
                              <p>Building/Wing/Flat Number</p>
                              {option.apartment.map((option1) => (
                                <b className="forTypeStInr">
                                  <b
                                    onClick={() =>
                                      navigate("/ApartmentHistory")
                                    }
                                  >
                                    {option1.is_current_stay == true ?
                                      <>
                                        {option1.uniq_apt_name}</>
                                      :
                                      <></>}
                                  </b>
                                  {/* <em>{option1.occupancy_type}</em> */}
                                </b>
                              ))}
                            </div>
                          ) : (
                            <div>No Apartment Allocated </div>
                          )}
                          <div className="visitBottCont">
                            <p>Committy Designation</p>
                            <b>{option.user_designation}</b>
                          </div>
                          <div className="resideNewCont">
                            <CreateIcon
                              className="editBt"
                              onClick={handleClickOpen2("body", option, option.resident_id, option.user_designation)}
                            />
                            <DeleteIcon className="deleteBt" onClick={() => deleteCommiteeMem(option.resident_id)} />
                          </div>
                        </div>
                      </div>
                    ))}

                    <Grid container spacing={3} >
                      <Grid item xs={12} md={12} >
                        <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                          page={currentPage}
                          onChange={handlePageChange}
                          variant="outlined"
                          shape="rounded" />
                      </Grid>
                    </Grid>
                  </>
                  :
                  <div>No Committee Members Added</div>
                }
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3} className="addCommitee1">

                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">Resident Name</label>
                  <input className="modalInputSt" placeholder="Resident Name" value={residentName} disabled />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">Select Designation</label>
                  <select className="modalInputStSelect"
                    value={designation}
                    onChange={
                      handleChangeDesignation
                    }
                  >
                    <option>Select Designation</option>
                    <option value="General Manager">General Manager</option>
                    <option value="Chairman">Chairman</option>
                    <option value="Treasurer">Treasurer</option>
                    <option value="Secretary">Secretary</option>
                    <option value="Committee Member">Committee Member</option>
                  </select>
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button className="modalMainBt" onClick={addCommiteeMember}>
                      Edit Member
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default CommitteeManagementNew;
